<template>
  <div class="poetic-verse-container" v-html="line.html"></div>
</template>

<script>
  export default {
    props: ['line'],
  };
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";

  .poetic-verse-container {
    // @@@ ::v-deep required due to use of v-html and scoped
    ::v-deep .poetic-verse {
      font-size: 0.925em;
    }
    ::v-deep .half-line {
      color: $gray-700;
    }
    ::v-deep .half-line:nth-child(2) {
      margin-inline-start: 5%;
      margin-block-end: 10px;
    }
  }
</style>
